import $models from '@/models'
import $store from '@/store'

const $activity = $models.activity;

const log = (...args) => { console.log("[API:activity]", ...args) };

// -----------------------------------------------------------------------------
function _activity_create({ goal_id, data }) {
  log("activity_create", goal_id, data);
  return $activity.with({ goalId: goal_id }).add( data, null, { directWrite: true } );
}

// -----------------------------------------------------------------------------
export function activity_create_comment({ goal_id, text }) {
  let userId = $store.getters["user/userAuth"].id;
  let new_activity = $activity.empty({ userId, activityType: 'USER_COMMENT' })
  new_activity.text = text;

  return _activity_create({ goal_id, data: new_activity });
}

// -----------------------------------------------------------------------------
export function activity_create_log({ goal_id, member_id, task_id }) {

  let userId = $store.getters["user/userAuth"].id;
  let new_activity = $activity.empty({ userId, activityType: 'LOGGED' })
  new_activity.taskId = task_id;
  new_activity.taskOwnerId = member_id;

  return _activity_create({ goal_id, data: new_activity });
}

// -----------------------------------------------------------------------------
export function activity_create_reply({ goal_id, activity_id, text }) {

  let userId = $store.getters["user/userAuth"].id;
  let new_activity = $activity.empty({ userId, activityType: 'USER_REPLY' })
  new_activity.originalActivityId = activity_id;
  new_activity.text = text;

  return _activity_create({ goal_id, data: new_activity });
}

// -----------------------------------------------------------------------------
export function activity_delete({ goal_id, activity_id }) {
  log("activity_delete", goal_id, activity_id);
  return $activity.with({ goalId: goal_id }).remove( activity_id );
}

// -----------------------------------------------------------------------------
export function activity_like({ goal_id, activity_id }) {
  let currentUserId = $store.getters["user/userAuth"].id;

  let activity = $activity.with({ goalId: goal_id });

  let promiseTransaction = activity.transaction( activity_id, 'numOfLikes', 'inc', 1 )
  let promiseAddUser = activity.update(activity_id, {
    ['likesBy/' + currentUserId]: true
  })

  /*
  let docRef = $activity.with({ goalId: goal_id }).childRef( activity_id );

  // TODO: move to store
  let promiseTransaction = docRef
    .child('numOfLikes')
    .transaction((queue_length) => {
      if ( queue_length || queue_length === 0 ) {
        queue_length++;
      }
      return queue_length;
  })

  let promiseAddUser = docRef
    .child('likesBy')
    .child(currentUserId)
    .set(true)
  */

  return Promise.all([promiseTransaction, promiseAddUser])
}
